import { BaseWebComponentRepository } from '../../../../framework/BaseWebComponentRepository';
import { QueryExecution } from '../../types';
import { LiveSearchMetadataGridViewData } from '../types';
import { LiveSearchMetadataGridDataProviderFactory } from '../factory/LiveSearchMetadataGridDataProviderFactory';
import { LiveSearchMetadataGridViewDataProvider } from '../dataProvider/LiveSearchMetadataGridViewDataProvider';

export default class LiveSearchMetadataGridRepository extends BaseWebComponentRepository {
  public dataProviderFactory: LiveSearchMetadataGridDataProviderFactory;
  public dataProvider: LiveSearchMetadataGridViewDataProvider;

  constructor() {
    super();

    this.initialSetup({
      dataProviderFactory: new LiveSearchMetadataGridDataProviderFactory(),
    });
  }

  getDataForView(queryExecution: QueryExecution | null): LiveSearchMetadataGridViewData {
    return this.dataProvider.getDataForView(queryExecution);
  }
}
